export interface IValueDepreciationConstants {
  lowYear1: number;
  lowYear2to5: number;
  lowYear6to20: number;
  lowYear21to30: number;
  mediumYear1: number;
  mediumYear2to5: number;
  mediumYear6to20: number;
  mediumYear21to30: number;
  highYear1: number;
  highYear2to5: number;
  highYear6to20: number;
  highYear21to30: number;
}

export const ValueDepreciationConstants: IValueDepreciationConstants = {
  lowYear1: 0.19,
  lowYear2to5: 0.12,
  lowYear6to20: 0.11,
  lowYear21to30: 0.1,
  mediumYear1: 0.22,
  mediumYear2to5: 0.15,
  mediumYear6to20: 0.13,
  mediumYear21to30: 0.12,
  highYear1: 0.25,
  highYear2to5: 0.18,
  highYear6to20: 0.16,
  highYear21to30: 0.15,
};
